<app-enfaf-modal
  (onClose)="confirmCloseModal()"
  buttonCancelText="Cancelar"
  [buttonConfirmText]="data.messageId ? 'Guardar' : 'Añadir mensaje'"
  (onConfirm)="saveMessage()"
  [isLoading]="isSavingMessage"
  [disableConfirmButton]="shouldDisableConfirmButton"
  svgIcon="message-circle-dark"
  [title]="data.messageId ? 'Editar mensaje' : 'Nuevo mensaje'"
>
  <form [formGroup]="messageForm" class="modal-content">
    <div class="modal-content-row">
      <enfaf-input
        color="light"
        label="Título del mensaje"
        placeholder="Título del mensaje"
        [control]="messageForm.controls.title"
        name="title"
        autocomplete="off"
        type="text"
        errorLabel="Título requerido"
      />

      <enfaf-input
        color="light"
        label="ID del Bot de Kommo"
        placeholder="Ej: 123456"
        [control]="messageForm.controls.kommoBotId"
        name="kommoBotId"
        autocomplete="off"
        type="text"
        [errorLabel]="kommoBotIdErrorLabel"
        [pending]="messageForm.controls.kommoBotId.status === 'PENDING'"
        [valid]="messageForm.controls.kommoBotId.valid && !!messageForm.controls.kommoBotId.value"
      />
    </div>

    <div class="modal-content-row">
      <enfaf-select-light
        label="¿Cuándo se envía?"
        placeholder="¿Cuándo se envía?"
        [control]="messageForm.controls.sendCondition"
        name="sendCondition"
        [options]="sendConditionOptions"
        errorLabel="Condición de envío requerida"
        color="light"
      >
      </enfaf-select-light>

      @if (isSendConditionFlashOrInactivity) {
        <enfaf-input
          class="offset-input"
          color="light"
          [label]="conditionOffsetLabel"
          [control]="messageForm.controls.offset"
          name="offset"
          autocomplete="off"
          type="number"
          errorLabel="Requerido"
          [showNumberSpinners]="true"
        />
      }
    </div>

    @if (!isSendConditionClassCompletion) {
      <div class="modal-content-row">
        <enfaf-select-light
          [options]="messageCourseModes"
          [control]="messageForm.controls.mode"
          [placeholder]="'Cursos en los que se envía'"
          [label]="'Cursos en los que se envía'"
        />
      </div>
    }

    <!-- Lista de cursos seleccionados -->
    @if (!isAllCoursesMode) {
      <div class="selected-courses-container">
        <div class="selected-courses-title">Cursos seleccionados:</div>

        <enfaf-multi-autocomplete-light
          (selectedChanged)="handleSelectedCourses($event)"
          #courses
          [placeholder]="'Buscar'"
          [fetchData]="fetchCourses"
          class="selected-courses-mode"
        >
        </enfaf-multi-autocomplete-light>

        @if (selectedCourses.length > 0) {
          <div class="selected-courses-list">
            @for (course of selectedCourses; track course) {
              <div class="course-item">
                <span class="course-name">{{ course.title }}</span>
                <app-enfaf-icon
                  [svgIconName]="'trash-red'"
                  [iconSize]="'16px'"
                  [iconStyle]="{ color: '#E03131' }"
                  [isButton]="true"
                  (onClick)="removeCourse(course)"
                  class="remove-icon"
                >
                </app-enfaf-icon>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Add more form fields as needed -->
  </form>
</app-enfaf-modal>
